<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Gastos</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar valor en los campos</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="search"
								placeholder="Ingresa nit, proveedor, serie..." name="filterVendors"
								class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" name="startDate" id="startDate" [(ngModel)]="startDate"
							(change)="checkDateValue()" class="form-control">
					</div>
					<div class="col-sm form-group">
						<label for="endDate" class="form-label">Fecha Final</label>
						<input type="date" name="endDate" id="endDate" min="{{startDate}}" (change)="checkDateValue()"
							[(ngModel)]="endDate" class="form-control">
					</div>
				</div>
				<div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
					<table class="table table-striped" style="margin-bottom: 0; margin-top: 10px;">
						<thead>
							<tr>
								<th class="ta th-balance" [class.balance-success]="total>=0" colspan="9">Total
									{{total | currency:'Q'}}</th>
							</tr>
							<tr class="tr-middle">
								<th class="ta">
									NIT
								</th>
								<th class="limit-td">
									Proveedor
								</th>
								<th class="ta">
									Serie
								</th>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Categoría
								</th>
								<th class="ta">
									Monto
								</th>
								<th class="ta">
									Fecha Documento
								</th>
								<th class="ta">
									Fecha Ingreso
								</th>
								<th>

								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let expense of pagination.filter">
								<tr class="tr-middle">
									<td class="ta">
										{{expense.nit}}
									</td>
									<td class="limit-td-100">
										{{expense.vendorName}}
									</td>
									<td class="ta">
										{{expense.series}}
									</td>
									<td class="ta">
										{{expense.number}}
									</td>
									<td class="ta" style="min-width: 200px; max-width: 200px;">
										<ng-container *ngIf="!editing[expense.id]">
											{{expense.category}}
											<i class="fa fa-edit clickeable text-info"
												(click)="editCategory(expense)"></i>
										</ng-container>
										<ng-container *ngIf="editing[expense.id]">
											<div class="input-group">
												<app-loading-button [object]="buttonEditCategory"
													(clicked)="updateCategory(expense, expense.category)"
													[disabled]="!editing[expense.id].value"></app-loading-button>
												<app-input-autocomplete
													[filterElements]="editing[expense.id].filterElements"
													(changeStatus)="selectCategory($event.filterElement, editing[expense.id])"
													[inputs]="editing[expense.id]"
													(inputMethod)="writeCategory(editing[expense.id])"
													(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
											</div>
										</ng-container>
									</td>
									<td class="ta">
										{{expense.total | currency: (expense.currency==0? 'Q' : '$')}}
									</td>
									<td class="ta">
										{{expense.date | date: 'YYYY/MM/dd'}}
									</td>
									<td class="ta">
										{{expense.creationDate | date: 'YYYY/MM/dd'}}
									</td>
									<td class="ta">
										<div class="d-flex flex-row justify-between">
											<span class="text-danger" (click)="showModalOption(expense)">
												<i *ngIf="deleting[expense.id] != true" class="fa fa-trash"></i>
												<span *ngIf="deleting[expense.id] === true"
													class="spinner-border spinner-border-sm"></span>
											</span>
											<span class="clickeable text-info" title="Trasladar"
												(click)="movingToWarehouse(expense)" [appCheckPermission]="[5060]"
												[permissionType]="permissionType.ALL">
												<i *ngIf="!moving[expense.id]" class="fa-solid fa-truck-ramp-box"></i>
												<span *ngIf="moving[expense.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
											<!-- <span class="clickeable text-info" title="Asignar Destino"
												(click)="assignDetination(expense)" [appCheckPermission]="[5060]"
												[permissionType]="permissionType.ALL">
												<i *ngIf="!assigning[expense.id]" class="fa-solid fa-location"></i>
												<span *ngIf="assigning[expense.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span> -->
											<span class="clickeable text-info" title="Enviar a Bodega"
												(click)="assignWarehouse(expense)" [appCheckPermission]="[5060]"
												[permissionType]="permissionType.ALL">
												<i *ngIf="!assigningWarehouse[expense.id]" class="fa-solid fa-warehouse"></i>
												<span *ngIf="assigningWarehouse[expense.id]" 
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span> 
											<span (click)="detailingInvoice(expense)" title="Ver detalle"
													class="clickeable text-info">
													<i *ngIf="!detailing[expense.id]" class="fa fa-eye"></i>
													<span *ngIf="detailing[expense.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
											<!-- <span class="clickeable text-info" title="Generar Documento Fiscal"
												(click)="generateFiscalDocument(expense)">
												<i class="fa fa-file-invoice"></i>
											</span> -->
											<span (click)="openApplyPP(expense)" title="Aplicar a PP"
													class="clickeable" [ngClass]="(applyExpense[expense.documentId]==null)? 'text-warning':''">
													<i *ngIf="!appliesPP[expense.id]" class="fa fa-cubes"></i>
													<span *ngIf="appliesPP[expense.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron documentos en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
	<div class="modal" tabindex="-1" *ngIf="invoiceDetail">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Detalles de Gasto</h1>
				</div>
				<div class="modal-body">
					 <p class="p-invoice" style="text-align: right;">Serie <b>{{invoiceDetail.series}}</b></p>
					<!--<p class="p-invoice" style="text-align: right;">Número <b>{{invoiceDetail.number}}</b></p>
					<p class="p-invoice" style="text-align: right;">Guatemala <b>{{invoiceDetail['dateString']}}</b>
					</p>
					<p class="p-invoice">Nombre <b>{{invoiceDetail.name}}</b></p>
					<p class="p-invoice">Nit <b>{{invoiceDetail.nit}}</b></p>
					<div>
						<table class="table table-striped">
							<thead>
								<tr>
									<th class="td-center">
										Cantidad
									</th>
									<th>
										Producto
									</th>
									<th>

									</th>
									<th class="td-center">
										Precio
									</th>
									<th class="td-center">
										Total
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let product of invoiceDetail['detail']">
									<td class="td-center">{{product.quantity}}</td>
									<td>
										{{product.productData.name}}
									</td>
									<td class="td-center"></td>
									<td class="td-center">{{product.price+product.taxes | currency : 'Q. '}}</td>
									<td class="td-center">{{product.quantity * (product.price+product.taxes) |
										currency
										: 'Q. '}}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr class="tr-middle">
									<td colspan="4">Total</td>
									<td colspan="4" class="td-center">{{invoiceDetail.totalCost +
										invoiceDetail.totalExtraTax +
										invoiceDetail.totalTaxes | currency : 'Q. '}}
									</td>
								</tr>
							</tfoot>
						</table> 
					</div>-->
				</div>
				<div class="modal-footer">
					<button class="btn btn-primary" (click)="invoiceDetail = null">
						<i class="fa fa-xmark"></i>CERRAR</button>
				</div>
			</div>
		</div>
	</div>
</div>
<app-simple-modal title="RAZON" *ngIf="toDelete" (close)="toDelete = null;" [max]="50" [requiredFields]="false">
	<div fields>
		<div class="container-message">
			<i class="fa fa-circle-question" style="font-size: 3em;"></i>
			<span class="message">
				¿Cuál es la razón para eliminar el gasto
				<b>{{toDelete['category']}}</b>?</span>
		</div>
		<div class="form-group">
			<textarea id="reason" name="reason" [(ngModel)]="reason" class="form-control"></textarea>
		</div>
	</div>
	<div buttons>
		<button class="btn btn-danger" [disabled]="!reason" (click)="deleteExpense()">
			<i class="fa fa-trash"></i>
			ELIMINAR
		</button>
	</div>
</app-simple-modal>
<app-simple-modal 
  title="Asignar Bodega" 
  *ngIf="assigningWarehouseForModal"
  (close)="assigningWarehouseForModal = false">

  <div fields>
    <div class="input-group input-group-sm mb-2">
      <label class="input-group-text">Bodega</label>

      <app-input-autocomplete
        [inputs]="inputWarehouse"
        [filterElements]="inputWarehouse.filterElements"
        [placeholder]="'Buscar bodega'"
        (inputMethod)="handleWarehouseInput(inputWarehouse)"
        (changeStatus)="selectWarehouse($event.filterElement, inputWarehouse)"
        (getTitle)="$event.filterElement.title = $event.filterElement.name">
      </app-input-autocomplete>

    </div>
  </div>

  <div buttons>
    <button class="btn btn-success"
      [disabled]="!inputWarehouse.verified"
      (click)="confirmAssignWarehouse()">
      <i class="fa fa-check"></i> ASIGNAR
    </button>
  </div>

</app-simple-modal>
<app-modal-question *ngIf="questionForModal" [question]="questionForModal" (close)="closeCreateCategory($event)" [title]="'Crear categoria'"></app-modal-question>

<app-detail-docs *ngIf="toggleModal"  [expenseDoc]="currentDoc" [docId]="currentDocId" [showModal]="toggleModal" (closed)="closeModal($event)"/>

<app-modal-assigning-detination-expense [showModal]="assigningForModal" [currentExpense]="currentExpense" *ngIf="assigningForModal" (closed)="closeModalAssign($event)"/>

<app-applies-pp *ngIf="toggleModalPP"  [expenseDoc]="currentDoc" [docId]="currentDocId" [showModal]="toggleModalPP" (closed)="closeModalPP($event)"/>